import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { HourOfOperationPropType } from '../../services/proptypes';
import CurrentlyOpenLabel from './CurrentlyOpenLabel';
export default function HoursOfOperationDailyWithPopup(_ref) {
  var displayOpenClosedStatus = _ref.displayOpenClosedStatus,
      timezone = _ref.timezone,
      hours = _ref.hours,
      children = _ref.children,
      label = _ref.label,
      secondaryLabel = _ref.secondaryLabel;
  var visibleFirstDay;

  if (displayOpenClosedStatus && timezone) {
    visibleFirstDay = /*#__PURE__*/React.createElement("div", {
      className: "hoo-withpopup-first"
    }, /*#__PURE__*/React.createElement(CurrentlyOpenLabel, {
      hours: hours,
      timezone: timezone
    }), secondaryLabel, /*#__PURE__*/React.createElement(Icon, {
      name: "caret down"
    }));
  } else {
    visibleFirstDay = /*#__PURE__*/React.createElement("div", {
      className: "hoo-withpopup-first"
    }, /*#__PURE__*/React.createElement("header", {
      className: "h4"
    }, label), /*#__PURE__*/React.createElement("p", {
      className: "hoo-hours-paragraph"
    }, secondaryLabel), /*#__PURE__*/React.createElement(Icon, {
      name: "caret down"
    }));
  }

  return /*#__PURE__*/React.createElement(Popup, {
    className: "hoo-popup",
    position: "bottom left",
    trigger: visibleFirstDay,
    content: children,
    basic: true,
    on: "click"
  });
}
HoursOfOperationDailyWithPopup.defaultProps = {
  timezone: null,
  label: 'See hours',
  secondaryLabel: ''
};